import React from 'react';

import { useCurrentUserPermissions } from 'src/hooks/user';
import { NotFoundErrorPage } from 'src/pages/not-found';

import {
  VerificationRequestsTableCVAdmin,
  VerificationRequestsTableCVManager,
  VerificationRequestsTableEmployerAdmin,
  VerificationRequestsTableEmployerManager,
  VerificationRequestsTablePEOAdmin,
  VerificationRequestsTablePEOManager,
  VerificationRequestsTablePeoPayrollProvider,
  VerificationRequestsTableVerifierAdmin,
  VerificationRequestsTableVerifierManager,
} from './components';

export const VerificationRequestsTable: React.FC = () => {
  const {
    isPlatformAdmin,
    isPlatformManager,
    isEmployerAdmin,
    isEmployerManager,
    isVerifierAdmin,
    isVerifierManager,
    isPeoSuperAdmin,
    isPeoAdmin,
    isPeoManager,
    isPeoPayrollProviderUser,
  } = useCurrentUserPermissions();

  if (isPlatformAdmin) return <VerificationRequestsTableCVAdmin />;
  if (isPlatformManager) return <VerificationRequestsTableCVManager />;

  if (isEmployerAdmin) return <VerificationRequestsTableEmployerAdmin />;
  if (isEmployerManager) return <VerificationRequestsTableEmployerManager />;

  if (isVerifierAdmin) return <VerificationRequestsTableVerifierAdmin />;
  if (isVerifierManager) return <VerificationRequestsTableVerifierManager />;

  if (isPeoSuperAdmin || isPeoAdmin) return <VerificationRequestsTablePEOAdmin />;
  if (isPeoManager) return <VerificationRequestsTablePEOManager />;

  if (isPeoPayrollProviderUser) return <VerificationRequestsTablePeoPayrollProvider />;

  return <NotFoundErrorPage />;
};
